import { createReducer, on } from '@ngrx/store';

import {
  fetchInternalOrderCodes,
  fetchInternalOrderCodesSuccess,
  fetchInternalOrderCodesFailure,
} from '../actions/internal-order.actions';

export interface IInternalOrderState {
  // raw map of id -> code as returned by the API; source of truth for the reverse lookup
  codesData: { [id: string]: string };
  fetching: boolean;
  fetched: boolean;
}

export const initialState: IInternalOrderState = {
  codesData: {},
  fetching: false,
  fetched: false,
};

export const internalOrderReducer = createReducer(
  initialState,
  on(fetchInternalOrderCodes, (state) => ({
    ...state,
    fetching: true,
  })),
  on(fetchInternalOrderCodesSuccess, (state, { codesData }) => ({
    ...state,
    fetching: false,
    fetched: true,
    codesData: codesData || {},
  })),
  on(fetchInternalOrderCodesFailure, (state) => ({
    ...state,
    fetching: false,
  })),
);
